import React from 'react';
import {
    IpsativeResponsesWrapper,
    AnswerOption,
} from 'components/questionnaire/IpsativeResponses.styled';
import { Questionnaire } from 'types/app';
import { getLocaleValue } from 'helpers/utils';
import { useTranslation } from 'react-i18next';

export interface IpsativeResponsesProps {
    answers: Array<Questionnaire.IIpsativeAnswer>;
    selectedAnswerId?: number;
    onSelect?: (answer: Questionnaire.IIpsativeAnswer) => void;
}

const IpsativeResponses: React.FC<IpsativeResponsesProps> = ({
    answers = [],
    selectedAnswerId,
    onSelect,
}) => {
    const { i18n, t } = useTranslation('translation');

    const handleSelect = (answer: Questionnaire.IIpsativeAnswer) => {
        onSelect && onSelect(answer);
    };

    return (
        <IpsativeResponsesWrapper>
            <p style={{
                color: 'var(--ion-color-medium)',
                fontSize: '0.9rem',
                marginBottom: '8px',
                textAlign: 'center',
                marginTop: 0
            }}>
                {t('questionnaire.choose-answer')}
            </p>
            {answers.map((answer) => {
                const isSelected = selectedAnswerId === answer.id;
                return (
                    <AnswerOption
                        key={`answer-${answer.id}`}
                        selected={isSelected}
                        onClick={() => handleSelect(answer)}
                    >
                        {getLocaleValue(answer.label, i18n.language)}
                    </AnswerOption>
                );
            })}
        </IpsativeResponsesWrapper>
    );
};

export default IpsativeResponses;
